var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"tp-empty-wrapper"},'div',_vm.$attrs,false),[_c('v-icon',{staticClass:"tp-empty-icon",attrs:{"size":"100"}},[_vm._v("mdi-text-box-search-outline")]),_c('div',[_vm._v(_vm._s(_vm.description))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }